export const MRQDetailsInputs = [
  {
    label: "Project Name",
    field: "projectName",
    grid: 0.7,
  },
  {
    label: "Made By",
    field: "drawnBy",
    grid: 0.5,
  },
  {
    label: "Checked By",
    field: "checkedBy",
    grid: 0.7,
  },
  {
    label: "Date",
    field: "mrqDate",
    grid: 0.5,
  },
  {
    label: "MRQ Number",
    field: "mrqNumber",
    grid: 0.7,
  },
  {
    label: "MRQ Rev",
    field: "rev",
    grid: 0.5,
  },
  {
    label: "Title",
    field: "title",
    grid: 0.7,
  },
];

// interface mrqMaterialsTableProps {
//     setEditedMaterials: React.Dispatch<React.SetStateAction<Record<string, Materials>>>
// }
